export default {
  pdfViewer: {
    ocorreuErro: 'Ocorreu um erro ao carregar o arquivo',
    carregando: 'Carregando...'
  }
};
